<template>
    <div class="app flex-row align-items-center">
        <div class="row" style="margin: 0px">
            <Loader style="padding-top: 30px" v-if="loading" />
            <div v-show="!loading" style="min-height: 100vh;" id="sport_div_iframe"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'LiveDigitain',
        data: function() {
            return {
                loading: false,
                scripts: '',
                params : {},
            }
        },
        created() {
            this.fetchData();
        },
        mounted() {
        },
        computed:{
            locale: function()
            {
                return this.$i18n.locale;
            },
        },
        methods: 
        {
            initHelpers: function(sportApp) {
                sportApp.addEventListener('sportAppEventDispatch', function ({ data }) {
                    console.log(data);
                });
            },
            fetchData: function() 
            {
                this.loading = true;
                axios.get('/sportsbook?service=digitain')
                .then((response)=>{


                    if (response.data.status) {
                        var auth_device = this.isMobile ? "mobile" : "desktop";
                        this.params = response.data.data;

                        // Dinamik script yükleme fonksiyonu
                        function loadScript(src, id) {
                            return new Promise((resolve, reject) => {
                                if (document.getElementById(id)) {
                                    console.warn(`Script already exists: ${id}`);
                                    return resolve();
                                }
                                var script = document.createElement("script");
                                script.id = id;
                                script.type = "text/javascript";
                                script.async = true;
                                script.src = src;

                                script.onload = () => resolve();
                                script.onerror = () => reject(new Error(`Script load error: ${src}`));

                                document.getElementsByTagName("head")[0].appendChild(script);
                            });
                        }

                        async function initializeIntegration(params, locale) 
                        {
                            try {
                                if (auth_device === "desktop") {
                                    await loadScript(params.jsURL, "js-content-desktop");
                                } else {
                                    await loadScript(params.mobileJsUrl, "js-content-mobile");
                                }

                                console.log("Scripts loaded successfully");

                                var dataPrepare = auth_device === "desktop"
                                    ? [
                                        ["server", params.server],
                                        ["token", params.token],
                                        ["currentPage", "Overview"],
                                        ["device", auth_device === "desktop" ? "d" : "m"],
                                        ["language", locale],
                                        ["login", "SportLogin"],
                                        ["registration", "SportRegistration"],
                                        ["timeZone", "3"],
                                        ["unHideOverflow", true],
                                        ["deposit", "Deposit"],
                                        //["customCssUrl", ""],
                                        //["customCssUrl", encodeURIComponent("https://cdn.wlstorages.com/digitain-sportsbook/test.css")],
                                        ["oddsFormat", "0"],
                                        ["oddsFormatList", [1, 2, 3]],
                                        ["onContentLoaded", "EventHandler"],
                                        ["sportsBookView", "europeanView"],
                                        ["fixedHeight", true],
                                        ["clearSiteStyles", false],
                                        ["isSuperTip", true],
                                        ["projectTheme", "default"],
                                        ["userId", params.user_id],
                                        ["sportPartner", params.partner_id],
                                        ["parent", ["seybet.com"]],
                                    ]
                                    : {
                                        server: params.server,
                                        containerId: "sport_div_iframe",
                                        token: params.token,
                                        defaultLanguage: locale,
                                        oddsFormatList: [0, 1, 2],
                                        oddsFormat: 2,
                                        zIndex: {
                                            closed: 1990,
                                            opened: 1923,
                                            fullOpened: 1827,
                                        },
                                        initialRoute: {
                                            path: "/",
                                            hashData: "",
                                        },
                                        parent: ["seybet.com"],
                                        sportPartner: params.partner_id,
                                        projectTheme: "default",
                                        timeZone: 3,
                                    };

                                console.log("dataPrepare:", dataPrepare);

                                var ready_digi = setInterval(() => {
                                    if (!_.isEmpty(params)) {
                                        if (auth_device === "desktop") {
                                            if (typeof SportFrame !== "undefined") {
                                                SportFrame.frame(dataPrepare);
                                                clearInterval(ready_digi);
                                            }
                                        } else {
                                            if (typeof Bootstrapper !== "undefined") {
                                                Bootstrapper.boot(dataPrepare, { name: "Mobile" });
                                                clearInterval(ready_digi);
                                            }
                                        }
                                    }
                                }, 100);
                            } catch (error) {
                                console.error("Error loading scripts:", error);
                            }
                        }

                        initializeIntegration(this.params, this.locale);
                    }

                })
                .catch((err)=>{
                })
                .finally(() => {
                    this.loading = false;
                });
            },

        }
    }
</script>
<style scoped>
    #sport_div_iframe{
        width: 100% !important;
    }
    #sport_div_iframe iframe{
        width: 100% !important;
    }
</style>